export default __webpack_public_path__ + "static/media/Quotes.1a89eb1b.svg";